<template>
  <v-dialog :value="model.active" width="600" persistent>
    <v-card v-if="selected">
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left> mdi-account-multiple-plus</v-icon>
          Assign Users
        </v-card-title>
        <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
         
        <v-form v-model="model.valid">
          <v-autocomplete
            v-model="selected.users"
            :items="users"
            filled
            dense
            outlined
            chips
            label="Assigned To"
            item-text="firstName"
            item-value="id"
            return-object
            multiple>
            <template v-slot:item="data">
              <UserAvatar :user="data.item" :hideRoles="true" :disableOpenLink="true"/>
            </template>
            <template v-slot:selection="data">
              <v-chip
                class="my-2"
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeUser(data.item)">
                <UserAvatar :user="data.item" :hideRoles="true" :disableOpenLink="true"/>
               
              </v-chip>
            </template>
          </v-autocomplete>
        </v-form>
        
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="closeDialog"> close </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
        <v-btn
          color="primary"
          elevation="0"
          @click="saveChanges"
          :disabled="!model.valid || !model.hasChanges">
          Assign
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  /* eslint-disable no-unused-vars */
  import formRules from '@Share/config/form-rules';
  import { $isEqual } from '@/utils';
  import { mapGetters } from 'vuex';
  import UserAvatar from '@Share/components/UserAvatar.vue';

  export default {
    name: 'AssignUsers',
    props: ['assetid'],
   
    data() {
      return {
        selected: {},
        selectedCemented: {},
        formRules,
        model: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
        },
        selectedType: null,
      };
    },
    computed: {
      ...mapGetters('USER', {
        users: 'GET_TYPEHEAD_ENTRIES',
      }),
    },
    methods: {
      open(selectedType) {
        this.model.active = true;
        this.selectedType = structuredClone(selectedType);
        if (selectedType) this.selected = structuredClone(selectedType);
        this.cementSelected();
      },
      saveChanges() {
        if (!this.selectedType.users) this.selectedType.users = [];
        this.selectedType.users = [...this.selected.users];
        this.$store.dispatch('TASK_MANAGER/UPDATE', this.selectedType).then((data) => {
          this.$emit('updateSelected', data);
          this.cementSelected();
          this.closeDialog();
        });
      },
      reset() {
        this.model.active = false;
        this.selected = null;
        this.selectedCemented = null;
      },
      closeDialog() {
        if (this.model.hasChanges) {
          const answer = window.confirm('You have unsaved changes on this page! leave anyway?');
          if (answer) {
            this.reset();
            this.discard();
          }
        } else {
          this.reset();
        }
      },
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
      },
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.model.active) return;

        this.model.hasChanges = !$isEqual(this.selected, this.selectedCemented);
      },
      removeUser(selectedUser) {
        const index = this.selected.users.map(e=>e.id).indexOf(selectedUser.id);
        if (index >= 0) this.selected.users.splice(index, 1);
      },
      save() {
        //save not completed
        if (this.selected.users.length == 0) return;
        else this.$emit('updateSelected', this.selected);
        this.cementSelected();
        this.closeDialog();
      },
    },
    created() {
      this.$store.dispatch('USER/GET_TYPEHEAD');
    },
    components: {UserAvatar},
    watch: {
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
    },
  };
</script>
